import { Link } from "@remix-run/react";
import { FaDiscord, FaExternalLinkAlt } from "react-icons/fa";

export default function RoadmapTodoItem({type}: {type: string}) {
return <div>    {type.length ? type : "This"} is on the todo list...
<a href="https://discord.com/servers/jaseowns-442558623298617354" className='md:mt-8 animate-slide-top duration-500 inline ml-2 underline hover:no-underline'>
    <div className="my-4 text-center border border-spacing-4 p-4 border-mute border-r-8 border-b-8 border-s-white border-t-white hover:border-t-muted-foreground hover:border-s-muted-foreground hover:bg-muted-foreground">
        <div className='text-2xl inline-block'>
            <b className="p-2">Let us know if you are interested about it in the</b>
            <FaDiscord className='inline text-4xl' style={{color: "#5865F2"}} /> Discord <FaExternalLinkAlt className='inline' />
            <p className="text-sm">
                Join the Jaseowns community discord as a <b>Server Subscriber</b> and support the project
            </p>
        </div>
    </div>
</a>
You can also check out the <Link to="/developer-roadmap" className="underline hover:no-underline">Developer Roadmap</Link> for more information.
</div>
}